// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main_30W5_","content":"index_content_3LEdy","mobile":"index_mobile_1TP45"};